import * as React from 'react';
import Popup from "reactjs-popup"

interface TimedProps {
    children: React.ReactNode
    closeIn?: number
    trigger: React.ReactNode
}

export const TimedPopup: React.FC<TimedProps> = ({ children, closeIn, trigger }) => {
    const [opened, setOpened] = React.useState(false)

    const close = () => setOpened(false)
    const open = () => setOpened(true)

    React.useEffect(() => {
        if (closeIn && opened) {
            const timer = setTimeout(() => {
                close()
            }, closeIn);
            return () => clearTimeout(timer);
        }
    }, [opened]);

    return <Popup trigger={trigger} onOpen={open} open={opened} onClose={close} closeOnDocumentClick modal>
        {children}
    </Popup>
}